function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.5 0.178574C19.7761 0.178574 20 0.402431 20 0.678574V31.0621L28.3737 21.4922C28.5556 21.2844 28.8714 21.2633 29.0793 21.4451C29.2871 21.627 29.3081 21.9429 29.1263 22.1507L19.8763 32.7221C19.7833 32.8284 19.6497 32.8904 19.5086 32.8928C19.3674 32.8952 19.2318 32.8378 19.1352 32.7348L9.22452 22.1634C9.03565 21.9619 9.04586 21.6455 9.24732 21.4567C9.44877 21.2678 9.76519 21.278 9.95405 21.4795L19 31.1285V0.678574C19 0.402431 19.2239 0.178574 19.5 0.178574ZM1 20C1.27614 20 1.5 20.2239 1.5 20.5V38.5H37.5V20.5C37.5 20.2239 37.7239 20 38 20C38.2761 20 38.5 20.2239 38.5 20.5V39.5H0.5V20.5C0.5 20.2239 0.723858 20 1 20Z",
  fill: "black"
});

var SvgSave = function SvgSave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/save.6813ed74.svg";
export { ForwardRef as ReactComponent };